var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgThermometer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "thermometer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.6668 12.2997V2.91634C11.6668 2.36381 11.4473 1.8339 11.0566 1.4432C10.6659 1.0525 10.136 0.833008 9.5835 0.833008C9.03096 0.833008 8.50106 1.0525 8.11036 1.4432C7.71966 1.8339 7.50016 2.36381 7.50016 2.91634V12.2997C6.83123 12.7466 6.32376 13.3969 6.05272 14.1543C5.78168 14.9118 5.76143 15.7364 5.99496 16.5063C6.22849 17.2761 6.70342 17.9505 7.34961 18.4297C7.9958 18.909 8.77898 19.1677 9.5835 19.1677C10.388 19.1677 11.1712 18.909 11.8174 18.4297C12.4636 17.9505 12.9385 17.2761 13.172 16.5063C13.4056 15.7364 13.3853 14.9118 13.1143 14.1543C12.8432 13.3969 12.3358 12.7466 11.6668 12.2997Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThermometer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/thermometer.f622117e.svg";
export { ForwardRef as ReactComponent };